var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0_1_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_2",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_2",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAACh0lEQVR4nO2YPWsUURSGR0VRTBQFA5IYwSogfqWxUdDWQoMp/Ae6CDb5BWKnCBZWgpgikogpgp2F1mKjrCn8QBAxrQoKiWajj1x4Fy5mdnfmzpy7s7ovDDvMOeee++w9585HkvTVQ8JWr4G9/wJIPBgkq3GjwWAPsuj9DpWdZ11Cq3GBPcAr85XBGETn9jBEAIkCQw6Qor6mMEQEMYUhw+SAk8Adr4FvAYdDxwWGSt/NOiTcCEyTrl/AtZBxTWA6gFyReQk4AwwAO4BJ4Ktsk3nHNYHpAFKX+XyKrSbb03bj5tSiFcgPmbe1aFqnbyWCYAXyUeaDwQlKmEcZIDdkfgscSnoYZAB4KZc1YA44DWwoMunoILK7Xeom8NMr5XfAFLA1OHFsEM9vH3AV+OQBfQBOBSfvBojnvwk4C7xQ6ApwJHgC3QL5665/V+GPgidgDQJ8l2lXm9jd8vkSPIEIIM9kutAmdqQXQKZkeg5sbhF7XT4LwROIALIdeC/zE+AEsFPXjwK3gd/AKnC8siBOwAHgDa31GTiXlCCsdy1gC3AZeOwBPAAuAYPBiWODlJrMUvyPIGUJGAUuAjP6EOHeQJd1LOnajHxGKweip+l7epLOqjXFDFYJZFbpGsC8XpePAcPuLVTHsK7V5ON8nWarBNJ8FZjIETOhmFUzEK/W72epda9cGsBD/evjetRprsiIrtXk08g0xxCQArWedp45zgKkSK077fd2rXrKSta9lXS+ZiBFat1pLEfcmCVIoVqnQj3SVM/3SKFap0I9UqjW6feI3Yr0ewSrHskiL2a5Cz2yYgHiPmbHvo/MJWVLz1rTAT3iYkLjSvs+kAaUVuvuW7A71tV60bg/QPpgAeXY1fQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.fcf48a8f3b35308c645ada838be94d9b.svg";
export { ForwardRef as ReactComponent };